module.exports = __webpack_public_path__ + "components/weather-icon/static/dayclear-af30c218df7d56904a79f3bd51b3c055.svg";